<script setup>
import { useStore } from '@/stores/index.js'
import { getInit, getLogged, checkPanelAccess } from '@/services/api.js'
import { setAnalyticsUser } from '@/services/analytics.js'

import HeaderItem from '@/components/header2025.vue'
import BadgesFree from '@/components/home/badges-free.vue'
import ItemRankCom from '@/components/home/rank-comment.vue'
import RankItem from '@/components/home/ranking.vue'
import SearchItem from '@/views/search.vue'
import FooterItem from '@/components/footer.vue'
import Alerta from '@/components/usefulness/alert.vue'
import PlayerFlutuante2 from '@/components/playerFlutuante2.vue'
import ClientOnly from '@/components/ClientOnly.vue'
import { useRoute } from 'vue-router'
import RankingFs from '@/components/home/ranking-fs.vue'
import { inject, onBeforeUnmount, onMounted, watch } from 'vue'

const store = useStore()
const route = useRoute()
const rollbar = inject('rollbar', null)

watch(
  () => store.initUser,
  (user) => {
    if (!rollbar || !user?.id) return
    rollbar.configure({
      payload: {
        person: {
          id: user.id,
          username: user.user,
        },
      },
    })
    setAnalyticsUser(user)
  },
  { immediate: true, deep: true },
)

function applyTheme(siteData) {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  root.style.setProperty('--color1', siteData.color1)
  root.style.setProperty('--color2', siteData.color2)

  const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = siteData.favicon
  document.getElementsByTagName('head')[0].appendChild(link)
}

async function initClient() {
  const needsSite = !store.initSite.logo
  const [siteData, logData] = await Promise.all([
    needsSite ? getInit() : Promise.resolve(null),
    getLogged(),
  ])

  if (siteData) {
    store.storeSite({
      header: siteData.header,
      logo: siteData.logo,
      logo_footer: siteData.logo_footer,
      favicon: siteData.favicon,
      clouds: siteData.clouds,
      color1: siteData.color1,
      color2: siteData.color2,
      maintenance: siteData.maintenance ?? 0,
    })
    applyTheme(siteData)
  } else if (store.initSite.color1) {
    applyTheme(store.initSite)
  }

  if (!logData.logged) {
    store.logged = false
    store.storeUser({ user: {}, logged: false })
  } else {
    store.storeUser({
      user: { user: logData.nick, id: logData.id, moedas: logData.score ?? 0 },
      logged: true,
    })
    const panelCheck = await checkPanelAccess().catch(() => ({ has_panel_access: false }))
    store.storePanelAccess(panelCheck?.has_panel_access ?? false)
  }

  store.player()
}

let radioInterval

onMounted(() => {
  initClient()
  radioInterval = setInterval(() => {
    store.player()
  }, 60000)
})

onBeforeUnmount(() => {
  if (radioInterval) clearInterval(radioInterval)
})
</script>

<template>
  <div v-if="store.initSite.maintenance === 1">
    <div style="margin-top: 80px; display: flex; justify-content: center;">
      Em manutenção.
    </div>
  </div>
  <div v-else>
    <HeaderItem />
    <div class="mx-4 xl:w-[1200px] max-w-[1200px] h-full xl:mx-auto flex flex-col-reverse xl:grid xl:grid-cols-[340px_1fr] gap-4 mt-4">
      <aside class="flex flex-col gap-4">
        <BadgesFree />
        <ItemRankCom />
        <RankItem />
      </aside>
      <div v-if="store.initSite.onSearch" class="main">
        <SearchItem :search="store.initSite.onSearch" @clear="store.initSite.onSearch = ''" />
      </div>
      <div v-else id="main" class="main scroll-mt-28 xl:max-w-[840px] xl:w-[840px]">
        <RouterView />
      </div>
    </div>
    <template v-if="route.fullPath === '/'">
      <RankingFs />
    </template>
    <FooterItem :logof="store.initSite.logo_footer" />
    <Transition name="slide-fade">
      <Alerta v-if="store.textA !== ''" :text="store.textA" />
    </Transition>
    <ClientOnly>
      <PlayerFlutuante2 />
    </ClientOnly>
  </div>
</template>

<style>
</style>
